<template>
  <div class="addOnlineContainer">
    <h2>编辑简历</h2>
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item ref="project_id" label="应聘项目" prop="project_id">
        <a-select
          style="width:200px"
          @change="selectRole"
          showSearch
          :filterOption="filterOption"
          placeholder="请选择应聘项目"
          v-model="ruleForm.project_id"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="应聘岗位" prop="role_id">
        <a-select
          style="min-width:200px"
          showSearch
          :filterOption="filterOption"
          v-model="ruleForm.role_id"
        >
          <a-select-option
            :value="element.id"
            v-for="(element, k) in roleList"
            :key="k"
            >{{ element.role_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="姓名" prop="name">
        <a-input v-model="ruleForm.name" />
      </a-form-model-item>
      <a-form-model-item label="手机号码" prop="phone">
        <a-input type="number" v-model="ruleForm.phone" />
      </a-form-model-item>
      <a-form-model-item label="居住地" prop="address">
        <a-input v-model="ruleForm.address" @change="addressSelect" />
        <span v-if="false">{{ selectTip.location }}</span>
        <ul class="tips" v-show="tipsToggle">
          <li
            class="tip"
            v-for="(tip, index) in tips"
            @click="selectTips(index)"
            :key="index"
          >
            <div>{{ tip.name }}</div>
            <div class="address">{{ tip.district + tip.address }}</div>
          </li>
        </ul>
      </a-form-model-item>
      <a-form-model-item label="性别" prop="gender">
        <a-radio-group v-model="ruleForm.gender">
          <a-radio :value="1">男</a-radio>
          <a-radio :value="2">女</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="年龄" prop="age">
        <a-input type="number" v-model="ruleForm.age" />
      </a-form-model-item>
      <a-form-model-item label="简历来源" prop="resume_source_id">
        <a-select
          style="min-width:200px"
          showSearch
          :filterOption="filterOption"
          v-model="ruleForm.resume_source_id"
        >
          <a-select-option
            :value="element.id"
            v-for="(element, k) in channelList"
            :key="k"
            >{{ element.source_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="教育程度" prop="education">
        <a-select v-model="ruleForm.education" style="width:200px">
          <a-select-option :value="1">
            初中及以下
          </a-select-option>
          <a-select-option :value="2">
            中专/高中
          </a-select-option>
          <a-select-option :value="3">
            专科
          </a-select-option>
          <a-select-option :value="4">
            本科
          </a-select-option>
          <a-select-option :value="5">
            硕士及以上
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="工作经历" prop="experienceVal">
        <ul class="experience">
          <li v-for="(item, index) in experienceList" :key="index">
            <a-select
              @change="selectedSkill"
              v-model="item.skill_name"
              placeholder="岗位"
              style="width:30%"
            >
              <a-select-option
                :value="element"
                v-for="(element, j) in skills"
                :key="j"
              >
                {{ element }}
              </a-select-option>
            </a-select>
            <a-select
              v-model="item.proficiency"
              placeholder="年限"
              style="width:30%;margin:0 10px;"
            >
              <a-select-option
                :value="element.id"
                v-for="(element, j) in yearList"
                :key="j"
              >
                {{ element.label }}
              </a-select-option>
            </a-select>
            <a-icon
              v-show="item.type == 'add'"
              style="font-size:24px;color:#67C23A"
              @click="changeExperience(item, index)"
              type="plus-circle"
            />
            <a-icon
              v-show="item.type == 'remove'"
              style="font-size:24px;color:#F56C6C"
              @click="changeExperience(item, index)"
              type="minus-circle"
            />
          </li>
        </ul>
      </a-form-model-item>
      <a-form-model-item label="性格标签" prop="resume_character">
        <a-checkbox-group v-model="ruleForm.resume_character">
          <a-checkbox v-for="item in characters" :key="item" :value="item">{{
            item
          }}</a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button @click="backPage" style="margin-right:20px">返回</a-button>
        <a-button type="primary" @click="submit" html-type="submit"
          >提交</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
import _ from "lodash";
import { pcaa } from "area-data";
export default {
  data() {
    let reg = /^[\u4e00-\u9fa5]{2,4}$/;
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      isDetailAddress: 0,
      ruleForm: {
        name: "",
        phone: "",
        gender: "",
        age: "",
        project_id: "",
        role_id: "",
        resume_source_id: "",
        address: "",
        address_detail: "",
        province: "",
        city: "",
        area: "",
        longitude: "",
        latitude: "",
        experienceVal: "",
        education: "",
        resume_character: []
      },
      rules: {
        resume_character: [
          {
            required: true,
            message: "请选择性格标签",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            len: 11,
            message: "手机号码格式错误",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "请输入居住地",
            trigger: "blur"
          }
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change"
          }
        ],
        age: [
          {
            required: true,
            message: "请输入年龄",
            trigger: "blur"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        role_id: [
          {
            required: true,
            message: "请选择岗位",
            trigger: "change"
          }
        ],
        resume_source_id: [
          {
            required: true,
            message: "请选择简历来源",
            trigger: "change"
          }
        ],
        experienceVal: [
          {
            required: true,
            message: "请选择工作经历",
            trigger: "change"
          }
        ],
        education: [
          {
            required: true,
            message: "请选择教育程度",
            trigger: "change"
          }
        ]
      },
      tips: [],
      selectTip: "",
      tipsToggle: false,
      proList: [],
      channelList: [],
      roleList: [],
      isShowRole: false,
      experienceList: [
        {
          skill_name: "",
          proficiency: "",
          type: "add"
        }
      ],
      skills: [
        "配送",
        "服务员",
        "保洁",
        "安保",
        "司机",
        "普工",
        "技工",
        "销售",
        "其他"
      ],
      yearList: [
        // {
        //   label: "无经验",
        //   id: 1
        // },
        {
          label: "小于1年",
          id: 2
        },
        {
          label: "1-3年",
          id: 3
        },
        {
          label: "3-5年",
          id: 4
        },
        {
          label: "大于5年",
          id: 5
        }
      ],
      characters: [
        "外向",
        "老实",
        "好学",
        "热情",
        "勤奋",
        "滑头",
        "自私",
        "易怒",
        "冷漠",
        "迟钝"
      ],
      detail: ""
    };
  },
  mounted() {
    this.getChannel(); //获取渠道
    this.getPro(); //项目列表
    if (this.editID != null) {
      this.getDetail();
    }
  },
  props: {
    editID: null
  },
  watch: {
    editID() {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_New/myResumeDetail";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          resume_id: this.editID
        })
        .then(res => {
          if (res.data.code == 200) {
            this.detail = res.data.data;
            // console.log(this.detail);
            let resume_character = [];
            if (this.detail.resume_character != "") {
              this.detail.resume_character.forEach(element => {
                resume_character.push(element.character_name);
              });
            }
            this.ruleForm = {
              name: this.detail.name,
              phone: this.detail.phone,
              gender: this.detail.gender,
              age: this.detail.age,
              project_id: this.detail.project_id,
              role_id: this.detail.role_id,
              resume_source_id: this.detail.resume_source_id,
              address: this.detail.address,
              address_detail: this.detail.address_detail,
              province: this.detail.province,
              city: this.detail.city,
              area: this.detail.area,
              longitude: this.detail.longitude,
              latitude: this.detail.latitude,
              education:
                this.detail.education == 0 ? "" : this.detail.education,
              experienceVal: this.detail.experienceVal,
              resume_character: resume_character
            };
            this.tipsVal = this.ruleForm.address;
            this.selectRole(this.detail.project_id);
            this.experienceList = [];
            if (this.detail.resume_skill != "") {
              this.detail.resume_skill.forEach((element, index) => {
                if (index == 0) {
                  this.experienceList.push({
                    skill_name: element.skill_name,
                    proficiency: element.proficiency,
                    type: "add"
                  });
                } else {
                  this.experienceList.push({
                    skill_name: element.skill_name,
                    proficiency: element.proficiency,
                    type: "remove"
                  });
                }
              });
              this.ruleForm.experienceVal = "val";
            } else {
              this.experienceList.push({
                skill_name: "",
                proficiency: "",
                type: "add"
              });
            }
            this.loading = false;
          }
        });
    },
    selectedSkill(val) {
      this.ruleForm.experienceVal = val;
    },
    changeExperience(item, index) {
      if (item.type == "add") {
        // this.skills.splice(this.skills.indexOf(item.post), 1);
        this.experienceList.push({
          skill_name: "",
          proficiency: "",
          type: "remove"
        });
      } else {
        // this.skills.push(item.post);
        this.experienceList.splice(index, 1);
      }
    },
    selectRole(val) {
      this.isShowRole = true;
      this.getRole(val);
    },
    getRole(val) {
      this.roleList = [];
      // this.role_id = "";
      this.isShowRole = false;
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "role/getRoleByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 10000,
          project_id: val
        })
        .then(res => {
          if (res.data.code == 200) {
            this.roleList = res.data.data;
            this.isShowRole = true;
          } else {
            this.isShowRole = true;
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
          }
        });
    },
    getChannel() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_source/resumeSourceList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.channelList = res.data.data.data;
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    addressSelect() {
      this.debounce = _.debounce(() => this.search(this.ruleForm.address), 100);
      this.debounce();
    },
    async search(keyword) {
      const url = "https://restapi.amap.com/v3/assistant/inputtips";
      const params = new URLSearchParams();
      params.append("keywords", keyword);
      // console.log(keyword)
      // 开发者key
      params.append("key", "0474a745d094cec483b7f9f988ba8216");
      params.append("output", "JSON");
      const { data } = await axios.get(`${url}?${params.toString()}`);
      // console.log(data.tips);
      if (data.status === "1") {
        this.tips = data.tips;
        if (data.tips.length > 0 && !this.hasdata) {
          this.tipsToggle = true;
        } else {
          this.tipsToggle = false;
        }
        setTimeout(() => {
          this.hasdata = false;
        }, 500);
      }
    },
    selectTips(index) {
      // event.stopImmediatePropagation()
      this.selectTip = this.tips[index];
      // this.getMap(this.selectTip.location)
      //  console.log(this.hasdata)
      if (this.selectTip.location.length > 0) {
        this.ruleForm.address = this.tips[index]["name"];
        this.ruleForm.address_detail =
          this.tips[index]["district"] + this.tips[index]["address"];
        var reg = /.+?(省|市|自治区|自治州|县|区)/g;
        let map = this.selectTip.district.match(reg);
        if (
          map[0] != "上海市" &&
          map[0] != "天津市" &&
          map[0] != "北京市" &&
          map[0] != "重庆市"
        ) {
          this.ruleForm.province = map[0];
          this.ruleForm.city = map[1];
          this.ruleForm.area = map[2];
        } else {
          this.ruleForm.province = map[0];
          this.ruleForm.city = map[0];
          this.ruleForm.area = map[1];
        }
        this.ruleForm.longitude = this.selectTip.location.split(",")[0];
        this.ruleForm.latitude = this.selectTip.location.split(",")[1];
        this.hasdata = true;
        this.tipsToggle = false;
      } else {
        this.$message.error("请输入详细地址");
        // this.keyword=""
      }
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url + this.httpsBasic.resume + "Resume_new/edit";
          let resume_skill = [];
          this.experienceList.forEach(element => {
            resume_skill.push({
              skill_name: element.skill_name,
              proficiency: element.proficiency
            });
          });
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            id: this.detail.id,
            name: this.ruleForm.name,
            phone: this.ruleForm.phone,
            address: this.ruleForm.address,
            address_detail: this.ruleForm.address_detail,
            province: this.ruleForm.province,
            city: this.ruleForm.city,
            area: this.ruleForm.area,
            longitude: this.ruleForm.longitude,
            latitude: this.ruleForm.latitude,
            gender: this.ruleForm.gender,
            age: this.ruleForm.age,
            project_id: this.ruleForm.project_id,
            role_id: this.ruleForm.role_id,
            resume_source_id: this.ruleForm.resume_source_id,
            resume_skill: JSON.stringify(resume_skill),
            education: this.ruleForm.education,
            resume_character: JSON.stringify(this.ruleForm.resume_character)
          };
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.backPage();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    backPage() {
      this.$refs.ruleForm.resetFields();
      this.$emit("hideIsEdit", false);
    }
  }
};
</script>
<style lang="less" scoped>
.addOnlineContainer {
  h2 {
    font-weight: normal;
    margin: 30px 0 20px 22%;
  }
  form {
    padding-bottom: 30px;
  }
  .ant-form-item {
    margin-bottom: 10px;
  }
  .tips {
    background: rgba(255, 64, 129, 0.03);
    padding: 10px 0;
    li {
      padding: 0 10px;
      cursor: pointer;
      > div {
        line-height: 26px;
      }
      .address {
        font-size: 12px;
        color: #999;
        line-height: 20px;
      }
    }
    li:hover {
      background: #fff;
    }
  }
}
</style>
